<!-- 财审策略编辑 - 策略明细 - 识别内容 表单定制
  根据【识别类型】动态切换【识别内容】的表单类型
  识别类型 = "付款方式" ==> display = select
-->
<template>
  <div class="IDENTIFY_CONTENT">
    <Input v-if="display == 'input'" :autocomplete="'new-password'" v-model="valuedata" placeholder="请输入识别内容" @on-blur="inputblur" @on-enter="inputenter"></Input>
    <Select v-else-if="display == 'select'" v-model="valuedata" :transfer="true" @on-change="selectChange">
      <Option v-for="item in _options" :key="item.value" :value="item.value">
        {{ item.label }}
      </Option>
    </Select>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
export default {
  name: 'IDENTIFY_CONTENT',
  props: {
    isShowCheckbox: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
    },
  },
  data() {
    return {
      valuedata: null,
      IDENTIFY_TYPE: null, // 识别类型
      display: 'input',
      _options: [],
    };
  },
  async mounted() {
    const options = await this.getSelectOption({ tableName: 'OC_B_ORDER', parentColName: '基本信息', childColName: ['PAY_TYPE'] });
    this.upAllOptions(options)
    this._options = options['PAY_TYPE'];
    this.$on('formItemChange', (res) => {
      console.log('表单变更监听成功::', res);
      this.IDENTIFY_TYPE = res.val;
      if (res.item.colname == 'IDENTIFY_TYPE') {
        if (this.IDENTIFY_TYPE == '4') {
          this.display = 'select';
          this.valuedata = '';
          this.$emit('change', '');
        } else {
          this.display = 'input';
          this.valuedata = '';
          this.$emit('change', '');
        }
      }
    });
  },
  watch: {
    valuedata(val) {
      this.$emit('change', val);
    },
  },
  methods: {
    ...mapActions('omsStore', ['getSelectOption']),
    ...mapMutations('omsStore', ['upAllOptions']),
    inputblur() {},
    inputenter() {},
    selectChange(val) {
      console.log('selectChange::', val);
      // this.$emit('change', val);
    },
  },
};
</script>

<style lang="less">
.IDENTIFY_CONTENT {
  /* .input-wrap {
    position: relative;
    .ark-input-wrapper {
    }
    .ark-icon {
      position: absolute;
      top: 3px;
      &.funnel {
        right: 1px;
      }
      &.clear {
        right: 20px;
      }
    }
  } */
}
</style>
